import React, { useState, useEffect } from "react";
import { get, post } from "../../utility/fetch";
import { RiCloseFill } from 'react-icons/ri';
import TagInputs from "../layouts/TagInputs";
import PlaceOrder from "./PlaceOrderModal";
import { calculateAge } from "../../utility/general";
import notification from "../../utility/notification";

function ActionReferralModal({ closeModal, referralInfo }) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    // State to hold the vital signs data
    const isMobile = window.innerWidth < 768;

    const [vitals, setVitals] = useState({
        dateOfVisit: '',
        temperature: '',
        bloodPressure: '',
        oxygenSaturation: '',
        bloodSugar: '',
        heartPulse: '',
        respiratory: '',
        height: '', // in cm
        weight: '', // in kg
        bmi: '',    // calculated
        vitalNurseEmployeeId: 0, // This would typically be populated from the logged-in user's info
        patientId: referralInfo?.patient?.id || 0,
        appointmentId: referralInfo?.appointmentId || 0,
        labRequestId: referralInfo?.id
    });


    const submitVitals = async () => {
        let res = await post("/vital", vitals);
        if (res?.statusCode === 200) {
            notification({
                type: "success",
                message: res?.data?.message
            })
        }
        else {
            notification({
                type: "error",
                message: "There was a problem creating vitals"
            })
        }
        console.log(res);
    }

    const openModal = async () => {
        setIsModalOpen(true);
        closeModal();
        console.log(vitals);
    };

    const close = () => {
        setIsModalOpen(false);
    };

    // Handler for updating vital input fields
    const handleVitalChange = (field) => (e) => {
        if (field === "height" || field === "weight" || field === "heartPulse" || field === "temperature") {
            setVitals(prevVitals => ({
                ...prevVitals,
                [field]: Number(e.target.value),
            }));
        }
        else {
            setVitals(prevVitals => ({
                ...prevVitals,
                [field]: e.target.value,
            }));
        }

    };

    // Effect to calculate BMI whenever height or weight changes
    useEffect(() => {
        if (vitals.height && vitals.weight) {
            const heightInMeters = parseFloat(vitals.height) / 100; // Convert cm to meters
            const weightInKg = parseFloat(vitals.weight);

            if (heightInMeters > 0 && weightInKg > 0) {
                const calculatedBmi = (weightInKg / (heightInMeters * heightInMeters)).toFixed(2);
                setVitals(prevVitals => ({
                    ...prevVitals,
                    bmi: parseFloat(calculatedBmi),
                }));
            } else {
                setVitals(prevVitals => ({ ...prevVitals, bmi: '' }));
            }
        } else {
            setVitals(prevVitals => ({ ...prevVitals, bmi: '' }));
        }
    }, [vitals.height, vitals.weight]);

    // Populate patientId and appointmentId from referralInfo on initial load
    useEffect(() => {
        setVitals(prevVitals => ({
            ...prevVitals,
            patientId: referralInfo?.patient?.id || prevVitals.patientId,
            appointmentId: referralInfo?.appointmentId || prevVitals.appointmentId,
            // Assuming vitalNurseEmployeeId comes from another source (e.g., auth context)
        }));
    }, [referralInfo]);


    return (
        <div className="overlay" style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0,0,0,0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 999
        }}>
            <RiCloseFill className='close-btn pointer' onClick={closeModal} />
            <div className="modal-content" style={isMobile ? { width: '95%', padding: '15px' } : {
                backgroundColor: 'white',
                padding: '30px',
                borderRadius: '8px',
                width: '90%',
                maxWidth: '900px',
                maxHeight: '90vh',
                overflowY: 'auto',
                position: 'relative'
            }}>
                <h2 style={{ marginBottom: '20px', textAlign: 'center' }}>Referral Details</h2>
                {/* <div className="tabs m-t-10 bold-text"></div> */} {/* Removed as it seems incomplete */}

                <div className="flex space-between" style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', flexDirection: isMobile ? 'column' : 'row', gap: isMobile ? '10px' : 0 }}>
                    <div className="col-6" style={{ flex: isMobile ? '1 1 100%' : '0 0 48%', marginBottom: '15px' }}>
                        <TagInputs label="Patient's Name" value={`${referralInfo?.patient?.firstName} ${referralInfo?.patient?.lastName}`} readOnly />
                    </div>
                    <div className="col-6" style={{ flex: isMobile ? '1 1 100%' : '0 0 48%', marginBottom: '15px' }}>
                        <TagInputs label='Clinic' value={referralInfo?.initiatedHealthCareProvider?.name} readOnly />
                    </div>
                </div>
                <div className="flex space-between" style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', flexDirection: isMobile ? 'column' : 'row', gap: isMobile ? '10px' : 0 }}>
                    <div className="col-6" style={{ flex: isMobile ? '1 1 100%' : '0 0 48%', marginBottom: '15px' }}>
                        <TagInputs label="Patient's Age" value={`${calculateAge(referralInfo?.patient?.dateOfBirth)}`} readOnly />
                    </div>
                    <div className="col-6" style={{ flex: isMobile ? '1 1 100%' : '0 0 48%', marginBottom: '15px' }}>
                        <TagInputs label="Patient's Weight" value={`${referralInfo?.patient?.weight} Kg`} readOnly />
                    </div>
                </div>
                <div className="flex space-between" style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', flexDirection: isMobile ? 'column' : 'row', gap: isMobile ? '10px' : 0 }}>
                    <div className="col-6" style={{ flex: isMobile ? '1 1 100%' : '0 0 48%', marginBottom: '15px' }}>
                        <TagInputs label="Doctor's Name" value={`${referralInfo?.doctor?.firstName} ${referralInfo?.doctor?.lastName}`} readOnly />
                    </div>
                    {/* <div className="col-6" style={{ flex: '0 0 48%', marginBottom: '15px' }}>
                        <TagInputs label='Severity' value={referralInfo?.severity} readOnly />
                    </div> */}
                </div>
                <div className="flex space-between" style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', flexDirection: isMobile ? 'column' : 'row', gap: isMobile ? '10px' : 0 }}>
                    <div className="col-6" style={{ flex: isMobile ? '1 1 100%' : '0 0 48%', marginBottom: '15px' }}>
                        <TagInputs label='Date Initiated' value={new Date(referralInfo?.createdAt).toLocaleDateString()} readOnly />
                    </div>
                    <div className="col-6" style={{ flex: isMobile ? '1 1 100%' : '0 0 48%', marginBottom: '15px' }}>
                        <TagInputs label='Time Initiated' value={new Date(referralInfo?.dateAndTimeInitiated).toLocaleTimeString()} readOnly />
                    </div>
                </div>

              

                <table className="bordered-table m-t-20" style={{ width: '100%', borderCollapse: 'collapse', marginTop: '20px' }}>
                    <thead>
                        <tr style={{ backgroundColor: '#f2f2f2' }}>
                            <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>Lab Request</th>
                            <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>Diagnosis</th>
                        </tr>
                    </thead>
                    <tbody>
                        {referralInfo.testRequests.map((work, index) => (
                            <tr key={index}>
                                <td style={{ border: '1px solid #ddd', padding: '8px' }}>{index + 1}. {work?.referredInternalLabService?.name}</td>
                                {index === 0 && <td rowSpan={referralInfo?.testRequests?.length} style={{ border: '1px solid #ddd', padding: '8px' }}>{referralInfo.diagnosis}</td>}
                            </tr>
                        ))}
                    </tbody>
                </table>
                <div style={{ marginTop: '15px' }}>
                    <TagInputs label='Additional Notes' type='textArea' value={referralInfo?.status} readOnly multiline />
                </div>
                <button onClick={openModal} className="submit-btn m-t-20" style={{
                    display: 'block',
                    width: '100%',
                    padding: '12px 20px',
                    backgroundColor: '#28a745',
                    color: 'white',
                    border: 'none',
                    borderRadius: '5px',
                    fontSize: '16px',
                    cursor: 'pointer',
                    marginTop: '20px'
                }}>Proceed With Request</button>
            </div>
            {isModalOpen &&
                <PlaceOrder submitVitals={submitVitals} referralInfo={referralInfo} vitals={vitals} closeModal={close} /> // Pass vitals to PlaceOrder
            }
        </div>
    );
}

export default ActionReferralModal;
